/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Pressable, Icon, Text, Label, Tooltip } from '@components/atoms'

import {
	useAppDispatch,
	useAppSelector,
	EditMenuType,
	adminActions,
	AdminStateType,
} from '@redux/index'
import { grey } from '@mui/material/colors'

interface PropsType {
	readOnly?: boolean
}

export const AdminEditMenuPath = (props: PropsType) => {
	// redux dispatch
	const reduxDispatch = useAppDispatch()

	// redux state
	const editTempMenu: EditMenuType = useAppSelector(state => state.admin.editTempMenu)
	const editMenuMode: AdminStateType['editMenuMode'] = useAppSelector(
		state => state.admin.editMenuMode,
	)

	// variables
	const readOnly: boolean = props.readOnly ?? false
	const disabled: boolean = editMenuMode === 'update' && editTempMenu.id === ''

	const onOpenModal = () => {
		reduxDispatch(adminActions.MENU_OPEN_MODAL('menuTree'))
	}

	return (
		<View css={style}>
			<View
				className={`pathView ${disabled ? 'disabled' : ''} ${readOnly ? 'readOnly' : ''}`}
			>
				<Label style={{ position: 'absolute' }}>경로</Label>
				<Tooltip title="경로 변경을 원하시면 클릭하세요.">
					<Pressable
						className="pathButton"
						onClick={onOpenModal}
						disabled={disabled || readOnly}
					>
						<View className="pathButtonInnerView">
							<Icon name="folder" className="pathFolderIcon" />
							<Text category="p1" className="pathText">
								{editTempMenu.path.replace('root/', '/')}
							</Text>
						</View>
					</Pressable>
				</Tooltip>
			</View>

			<View className="uriView">
				<Label>uri</Label>
				<View className="uriInnerView">
					<Text category="c1" className="uriText">
						{editTempMenu.uri === '' ? '-' : editTempMenu.uri}
					</Text>
				</View>
			</View>
		</View>
	)
}

const style = css({
	marginBottom: '2rem',

	'.pathView': {
		position: 'relative',
		marginTop: '0.5rem',
		paddingTop: '1rem',

		'&.disabled': {
			'.pathButton': {
				borderBottom: `1px dotted ${grey[500]}`,

				'.pathButtonInnerView': {
					'.pathFolderIcon': {
						color: grey[300],
					},
				},
			},
		},

		'&.readOnly': {
			'.pathButton': {
				borderBottom: `1px dotted ${grey[600]}`,
				opacity: 0.8,

				'.pathText': {
					color: grey[800],
				},
			},
		},

		'.pathButton': {
			position: 'relative',
			display: 'flex',
			alignItems: 'flex-end',
			width: '100%',
			height: '2rem',
			padding: 0,
			borderBottom: `1px solid ${grey[500]}`,
			fontSize: '16px',

			'.pathButtonInnerView': {
				display: 'flex',
				alignItems: 'center',
				height: '1rem',
				marginBottom: '0.3rem',

				'.pathFolderIcon': {
					color: grey[500],
				},

				'.pathText': {
					margin: 0,
					marginLeft: '0.2rem',
					fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
					fontWeight: '400',
					fontSize: '1rem',
				},
			},
		},
	},

	'.uriView': {
		position: 'relative',
		display: 'flex',
		alignItems: 'center',

		'.uriInnerView': {
			display: 'flex',
			alignItems: 'center',
			marginLeft: '1rem',

			'.uriText': {},
		},
	},
})
